import {
  ped_main_steps,
  ped_sub_steps,
  step_status,
} from "helpers/enum";
import { setNextScreenToUpcoming } from "helpers/setPedStepStatus";

export const pedSelectSlotReducer = {
  select_slot(state, action) {
    const { status, value, isValid } = action.payload;
    if (status) {
      state.subSteps[ped_sub_steps.select_slot].status = status;
      if (status === step_status.completed) {
        state.mainSteps[ped_main_steps.main_select_slot].status =
          step_status.completed;
        if (
          state.mainSteps[ped_main_steps.basic_info].status ===
          step_status.upcoming
        ) {
          state.mainSteps[ped_main_steps.basic_info].status =
            step_status.current;
        }
        setNextScreenToUpcoming({
          state,
          status,
          nextScreen: ped_sub_steps.confirm_residence,
        });
      }
    }
    if (value !== undefined) {
      state.subSteps[ped_sub_steps.select_slot].value = value;
    }
    if (isValid !== undefined) {
      state.subSteps[ped_sub_steps.select_slot].isValid = isValid;
    }
  },
};
